/* global $ */

function init() {

	const $els = $('.share-links');

	$els.each((index, el) => {

		$(el).find('button').on('click', () => {

			$(el).find('.share-links__dropdown').toggleClass('is--hidden');

		});

	});

	$('body').on('click', (event) => {

		const clickedInside = $els.get().find((el) => el.contains(event.target));

		if (!clickedInside) {
			$('.share-links__dropdown').addClass('is--hidden');
		}

	});

	window.matchMedia('(min-width: 1040px)').addListener(() => {
		$('.share-links__dropdown').addClass('is--hidden');
	});

}

export default {
	init
};
